import * as React from 'react';

import type {DripSequenceStatus} from '../edition/get-edition-status-info';
import {StackLegacy} from '../layout/stack/stack-legacy';
import {FormattedTimestamp} from '../timestamp/formatted-timestamp';

type DripSequence = {
    status: DripSequenceStatus;
    lastStatusChangeTime: number | null | undefined;
    createdTime: number;
};

export const getDateForDripSequenceHeader = (dripSequence: DripSequence): React.ReactElement => {
    const timestamp = dripSequence.lastStatusChangeTime || dripSequence.createdTime;
    const formattedTimestamp = (
        <FormattedTimestamp
            datetime={timestamp}
            format={FormattedTimestamp.formats.simpleLongMonthDayYear}
            showDetailedPopover={true}
        />
    );

    let prefix = '';

    switch (dripSequence.status) {
        case 'DRAFT':
            prefix = 'Created';
            break;
        case 'ACTIVE':
            prefix = 'Activated';
            break;
        case 'PAUSED':
            prefix = 'Paused';
            break;
        case 'CANCELLED':
            prefix = 'Canceled';
            break;
        case 'RETIRED':
            prefix = 'Retired';
            break;
        case 'ARCHIVED':
            prefix = 'Archived';
            break;
        default:
            prefix = 'Created';
            break;
    }

    return (
        <StackLegacy isHorizontal={true} spacing={4} justifyContent='end'>
            {prefix}
            {formattedTimestamp}
        </StackLegacy>
    );
};
